import Immutable from 'immutable';
import {
  GET_SALES_TAXES,
  CLEAR_SALES_TAXES,
  FLAG_GETTING_SALES_TAX,
  GET_SALES_TAX,
  CLEAR_SALES_TAX,
  FLAG_GETTING_SALES_TAXES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_SALES_TAXES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_SALES_TAXES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_SALES_TAXES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_SALES_TAX:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_SALES_TAX:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_SALES_TAX:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    default:
      return state;
  }
};
